import './Box.sass';

export const Box = ({children, center, className = '', padding = 16, borderRadius = 4}) => (
  <div className={`box ${center ? 'box-center' : ''} ${className}`} style={{padding, borderRadius}}>
    {children}
  </div>
);
